import { BoxTunnelVpnProps } from '@/box/interface'
import { DisconnectOutlined, SwapOutlined } from '@ant-design/icons'
import { Button, Form, Input, Modal, Space } from 'antd'
import React, { useEffect, useState } from 'react'

export class InputExt extends React.Component<{ value?: string[] }> {
  private textLog

  constructor(props) {
    super(props)
    this.textLog = React.createRef()
  }

  componentDidUpdate() {
    this.textLog.current.scrollTop = this.textLog.current.scrollHeight
  }

  render() {
    let str = ''
    this.props.value?.forEach((x) => {
      str += x + '\n'
    })

    return (
      <div>
        <textarea
          readOnly
          className='ant-input'
          ref={this.textLog}
          value={str}
          style={{ minHeight: 200 }}
        />
      </div>
    )
  }
}

export const BoxTunnelVpn: React.FC<BoxTunnelVpnProps> = (
  props: BoxTunnelVpnProps
) => {
  const [type, setType] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [checking, setChecking] = useState<boolean>(false)
  const [checkVisible, setCheckVisible] = useState<boolean>(false)
  const [form] = Form.useForm()
  const [plcForm] = Form.useForm()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 }
    }
  }

  const wrapperCol = {
    xs: { span: 24 },
    sm: { span: 24 }
  }

  const handleConnectClick = () => {
    form
      .validateFields()
      .then((values) => {
        const merged = Object.assign(props.item, values)
        merged.clientStatus = 0
        merged.boxStatus = 0
        if (props.onConnect) {
          setType('connect')
          setLoading(true)
          props.onConnect(merged)
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info)
      })
  }

  const handleDisconnectClick = () => {
    if (props.onDisconnect) {
      setType('disconnect')
      setLoading(true)
      props.onDisconnect()
    }
  }

  const handleCheckClick = () => {
    setCheckVisible(true)
  }

  const handleCheckModalCancel = () => {
    setCheckVisible(false)
  }

  const handlePlcCheck = () => {
    plcForm
      .validateFields()
      .then((values) => {
        if (props.onPlcCheck) {
          setChecking(true)
          props.onPlcCheck(values.plcIp)
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info)
      })
  }

  useEffect(() => {
    if (props.item) {
      let desc = '未连接'
      if (props.item.boxStatus == 1 && props.item.clientStatus == 1) {
        desc = 'VPN透传已经准备好'
        if (type == 'connect') {
          setLoading(false)
        }
      }

      if (props.item.boxStatus == 0 && props.item.clientStatus == 0) {
        if (type == 'disconnect') {
          setLoading(false)
        }
      }

      if (props.item.clientStatus == 2 || props.item.boxStatus == 2) {
        setLoading(false)
      }

      setChecking(false)
      props.item.connectStatus = desc
      form.setFieldsValue(props.item)
    }
  }, [props.item])

  return (
    <div>
      <p>本操作将在本机与FBox之间建立虚拟专用网络(VPN)连接。</p>
      <Form form={form} {...formItemLayout}>
        <Form.Item label='连接状态' name='connectStatus'>
          <Input readOnly />
        </Form.Item>
        <Form.Item
          label='PLC网关'
          name='gateway'
          rules={[
            {
              required: true,
              message: 'PLC网关不能为空'
            }
          ]}
        >
          <Input disabled={loading} />
        </Form.Item>
        <Form.Item
          label='PLC子网掩码'
          name='subnetMask'
          rules={[
            {
              required: true,
              message: 'PLC子网掩码不能为空'
            }
          ]}
        >
          <Input disabled={loading} />
        </Form.Item>
        <p>
          说明:
          等待连接状态显示'VPN透传已经准备好'，则本机已经接入远程网络。可以如同在同一个局域网内一样通过IP地址直接远程操作设备。
        </p>
        <Form.Item wrapperCol={wrapperCol}>
          <InputExt value={props.item?.logs} />
        </Form.Item>
        <Form.Item wrapperCol={wrapperCol} style={{ textAlign: 'right' }}>
          <Space align='end'>
            <Button
              type='primary'
              onClick={handleCheckClick}
              disabled={
                props.item?.clientStatus !== 1 || props.item?.boxStatus !== 1
              }
            >
              检查链路
            </Button>
            {props.item?.clientStatus == 1 && props.item?.boxStatus == 1 ? (
              <Button
                type='primary'
                onClick={handleDisconnectClick}
                icon={<DisconnectOutlined />}
                loading={loading}
              >
                断开
              </Button>
            ) : (
              <Button
                type='primary'
                onClick={handleConnectClick}
                icon={<SwapOutlined />}
                loading={loading}
              >
                连接
              </Button>
            )}
          </Space>
        </Form.Item>
      </Form>
      <Modal
        destroyOnClose={true}
        maskClosable={false}
        title='链路测试'
        visible={checkVisible}
        onCancel={handleCheckModalCancel}
        footer={null}
        width={450}
      >
        <Form form={plcForm} {...formItemLayout}>
          <Form.Item
            label='设备IP'
            name='plcIp'
            rules={[
              {
                required: true,
                message: 'PLCIP不能为空'
              }
            ]}
          >
            <Input disabled={checking} />
          </Form.Item>

          <Form.Item wrapperCol={wrapperCol} style={{ textAlign: 'right' }}>
            <Space align='end'>
              <Button
                type='primary'
                onClick={handlePlcCheck}
                loading={checking}
              >
                测试
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
